const PARTNER_PASSWORD_SPECIAL = /[#?!@$%^&*-]/

export const PARTNER_PASSWORD_HINT =
  'At least 8 characters, with an uppercase letter, a lowercase letter, a digit, and one of #?!@$%^&*-.'

export const PASSWORD_ALREADY_CHANGED_MESSAGE =
  'This password was already changed. Contact Credibila for a new temporary password.'

export const getPartnerPasswordError = (newPassword: string) => {
  if (newPassword.length < 8) return 'Use at least 8 characters.'
  if (!/[A-Z]/.test(newPassword)) return 'Include an uppercase letter.'
  if (!/[a-z]/.test(newPassword)) return 'Include a lowercase letter.'
  if (!/\d/.test(newPassword)) return 'Include a digit.'
  if (!PARTNER_PASSWORD_SPECIAL.test(newPassword)) return 'Include one of #?!@$%^&*-.'
  return ''
}
